module.exports = __webpack_public_path__ + "static/img/manual-31.3dc27eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-31.png
// module id = njC8
// module chunks = 4